"use strict";

// Migrate old handle-based wishlist data to ID-based
(function() {
    var old = JSON.parse(localStorage.getItem('bls__wishlist-items'));
    if (old && old.length > 0 && isNaN(old[0])) {
        localStorage.removeItem('bls__wishlist-items');
    }
})();

// Detect shared wishlist from URL parameter (?shared=id1,id2,id3)
var shared_wishlist_ids = null;
(function() {
    var params = new URLSearchParams(window.location.search);
    var shared = params.get('shared');
    if (shared) {
        shared_wishlist_ids = shared.split(',').filter(function(id) { return id.trim() !== ''; });
    }
})();

const wishlist_items = shared_wishlist_ids || JSON.parse(localStorage.getItem('bls__wishlist-items'));
const wishlistDiv = document.querySelector('.bls__wishlist-page-main');
var BlsWishlistPageShopify = (function() {
    return {

        initWishlistItems: function() {
            if (window.location.search.indexOf("page=") == -1) {
                this.init();
            }
        },

        init: function () {
            const _this = this;
            if (wishlistDiv) {
                const div_no_product = wishlistDiv.querySelector('.bls__wishlist-no-product-js');
                if (wishlist_items === null || wishlist_items.length === 0) {
                    _this.skeletonFunction(0)
                    div_no_product.classList.remove('d-none');
                }else{
                    var query = '';
                    wishlist_items.forEach((e, key, wishlist_items) => {

                        if (!Object.is(wishlist_items.length - 1, key)) {
                        query += e+'%20OR%20id:';
                        }
                        else{
                        query += e;
                        }
                    })

                    var productAjaxURL = "?view=wishlist&type=product&options[unavailable_products]=last&q=id:"+query;
                    var domParser = typeof parser !== 'undefined' ? parser : new DOMParser();

                    fetch(`${window.routes.search_url}${productAjaxURL}`)
                    .then(response => response.text())
                    .then((responseText) => {
                        const html = domParser.parseFromString(responseText, 'text/html');
                        const row = document.createElement('div');
                        row.classList.add('row');
                        const exist_row = wishlistDiv.querySelector('.row');
                        if (exist_row) {
                            exist_row.remove();
                        }
                        const er = html.querySelector(".bls__wishlist-page-main > .row")
                        if(wishlist_items.length !== 0 && er){
                            wishlistDiv.innerHTML = html.querySelector(".bls__wishlist-page-main").innerHTML;
                            _this.skeletonFunction(700)
                            if (!shared_wishlist_ids) {
                                _this.mergeItems();
                            }
                        }else{
                            _this.skeletonFunction(0)
                            div_no_product.classList.remove('d-none');
                        }
                    }).catch((e) => {
                        console.error(e);
                    }).finally(e => {
                        BlsColorSwatchesShopify.init();
                        BlsSubActionProduct.handleInitQuickviewAction();
                        BlsSubActionProduct.init();
                        BlsLazyloadImg.init();
                        if (typeof BlsSectionProductAddCart !== 'undefined') {
                            BlsSectionProductAddCart.init();
                        }
                        _this.initShareUI();
                    })
                }
            }
        },
        mergeItems: function () {
            const arr = [];
            if (wishlistDiv) {
                wishlistDiv.querySelectorAll(".bls__product-item").forEach(e => {
                    arr.push(e?.dataset.productId);
                })
            }
            if (arr.length > 0) {
                localStorage.setItem('bls__wishlist-items',JSON.stringify(arr));
            }
        },
        skeletonFunction: function (timer) {
            window.setTimeout(function() {
                if (this.document.querySelector('skeleton-page')) {
                    this.document.querySelector('skeleton-page').remove();
                }
                if (this.document.querySelector('.bls__wishlist-page-section-inner')) {
                    this.document.querySelector('.bls__wishlist-page-section-inner').classList.remove('d-none');
                }
            },timer)
        },

        // --- Wishlist Sharing ---

        initShareUI: function() {
            var shareBar = document.querySelector('.bls__wishlist-share-bar');
            var sharedBanner = document.querySelector('.bls__wishlist-shared-banner');

            if (shared_wishlist_ids) {
                // Shared mode: show banner, hide share bar, hide remove-from-wishlist buttons
                if (sharedBanner) {
                    sharedBanner.classList.remove('d-none');
                    sharedBanner.style.display = 'flex';
                }
                if (shareBar) shareBar.classList.add('d-none');

                // Hide wishlist remove buttons in shared mode
                document.querySelectorAll('.bls__wishlist-btn, .bls__btn-wishlist').forEach(function(btn) {
                    btn.style.display = 'none';
                });

                // "Add All to My Wishlist" handler
                var addAllBtn = document.querySelector('.bls__wishlist-add-all');
                if (addAllBtn) {
                    addAllBtn.addEventListener('click', function() {
                        var existing = JSON.parse(localStorage.getItem('bls__wishlist-items')) || [];
                        shared_wishlist_ids.forEach(function(id) {
                            if (existing.indexOf(id) === -1 && existing.indexOf(Number(id)) === -1) {
                                existing.push(id);
                            }
                        });
                        localStorage.setItem('bls__wishlist-items', JSON.stringify(existing));
                        addAllBtn.textContent = 'Added!';
                        addAllBtn.disabled = true;
                        setTimeout(function() {
                            addAllBtn.textContent = 'Add All to My Wishlist';
                            addAllBtn.disabled = false;
                        }, 2000);
                    });
                }
            } else {
                // Own wishlist mode: show share bar if there are products
                var hasProducts = wishlistDiv && wishlistDiv.querySelectorAll('.bls__product-item').length > 0;
                if (shareBar && hasProducts) {
                    shareBar.classList.remove('d-none');
                    shareBar.style.display = 'flex';
                }
                if (sharedBanner) sharedBanner.classList.add('d-none');
            }

            this.initShareButtons();
        },

        generateShareURL: function() {
            var items = JSON.parse(localStorage.getItem('bls__wishlist-items')) || [];
            if (items.length === 0) return null;
            var base = window.location.origin + window.location.pathname;
            return base + '?shared=' + items.join(',');
        },

        initShareButtons: function() {
            var _this = this;

            // Copy Link
            var copyBtn = document.querySelector('.bls__wishlist-share-btn[data-action="copy-link"]');
            if (copyBtn) {
                copyBtn.addEventListener('click', function() {
                    var url = _this.generateShareURL();
                    if (!url) return;
                    navigator.clipboard.writeText(url).then(function() {
                        var label = copyBtn.querySelector('span');
                        var original = label.textContent;
                        label.textContent = 'Copied!';
                        copyBtn.style.borderColor = '#25D366';
                        copyBtn.style.color = '#25D366';
                        setTimeout(function() {
                            label.textContent = original;
                            copyBtn.style.borderColor = '#ddd';
                            copyBtn.style.color = 'inherit';
                        }, 2000);
                    });
                });
            }

            // WhatsApp
            var waBtn = document.querySelector('.bls__wishlist-share-btn[data-action="whatsapp"]');
            if (waBtn) {
                waBtn.addEventListener('click', function() {
                    var url = _this.generateShareURL();
                    if (!url) return;
                    var message = encodeURIComponent('Check out my wishlist on Biogreens! ' + url);
                    window.open('https://wa.me/?text=' + message, '_blank');
                });
            }

            // Email
            var emailBtn = document.querySelector('.bls__wishlist-share-btn[data-action="email"]');
            if (emailBtn) {
                emailBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    var url = _this.generateShareURL();
                    if (!url) return;
                    var subject = encodeURIComponent('My Biogreens Wishlist');
                    var body = encodeURIComponent('Check out the products on my wishlist:\n\n' + url);
                    window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
                });
            }
        }
      }
  })();
  BlsWishlistPageShopify.initWishlistItems();
